import React, { RefObject } from 'react';
import { HOME } from '@shared/constants/navigate';

export type Paths = 'about' | 'locations' | 'review' | 'partners' | 'contacts';

export const scrollTo = (
  ref: RefObject<HTMLDivElement>[] | RefObject<HTMLDivElement>,
  path: Paths
) => {
  const isRefsArray = Array.isArray(ref);

  if (isRefsArray) {
    const [aboutRef, locationsRef, reviewsRef, partnersRef, contactUsRef] = ref;

    switch (path) {
      case 'about':
        return aboutRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      case 'locations':
        return locationsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      case 'review':
        return reviewsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      case 'partners':
        return partnersRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

      case 'contacts':
        return contactUsRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
    }
  } else {
    ref?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};

export const scrollToPath = (
  e: React.MouseEvent<HTMLAnchorElement>,
  refs: RefObject<HTMLDivElement>[] | RefObject<HTMLDivElement>
) => {
  e.preventDefault();

  const path = e.currentTarget.getAttribute('href') as Paths | null;

  if (!path) return;

  if (window.location.pathname !== HOME) {
    localStorage.setItem('scrollTo', path);
    window.location.href = HOME;
    return;
  }

  scrollTo(refs, path);
};

export const onLogoClick = () => {
  const target = window.location.pathname;

  if (target !== HOME) {
    window.location.href = HOME;
  }
};
